import {
  ModalActionArea, ModalForm, Wrapper, ButtonContainer, CustomTextField,
  ModalIncompatibleInvoicesContainer,
  ModalIncompatibleInvoicesContainerItems,
  ModalIncompatibleInvoicesContainerInvoices,
  ModalIncompatibleInvoicesContainerInvoicesList,
  ModalIncompatibleInvoicesContainerInvoicesListItem,
} from './PreQueueTable.styles'

import { actions } from '../../SupplierState'
import { useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { State } from 'src/features/types'
import { useFulfillmentCenter } from 'src/hooks/useFulfillmentCenter'
import TableMui from 'src/components/TableMui'
import dayjs from 'dayjs'
import { ButtonMui } from 'src/components/ButtonMui/ButtonMui'
import Modal from 'src/components/Modal'
import TextFieldMui from 'src/components/TextFieldMui'
import { useForm } from 'react-hook-form'
import duration from 'dayjs/plugin/duration'
import { formatDifferenceFromNow } from 'src/utils/formatDifference'
import { formatDateUTC } from 'src/utils/formatDate'
import DoneIcon from '@mui/icons-material/Done'
import CloseIcon from '@mui/icons-material/Close'
import { PreQueueIncompatibleInvoices } from '../../SupplierTypes'
import { Typography } from '@mui/material'
import ModalAlert from 'src/components/ModalAlert'

dayjs.extend(duration)
interface FormType {
  badge: string
}

const invoiceReadyIconSx = {
  width: '17px',
  height: '17px',
  marginLeft: '3px',
  marginBottom: '2px',
}

export const PreQueueTable = () => {
  const supplierState = useSelector((state: State) => state.supplier)
  const [searchTerm, setSearchTerm] = useState<string>('')
  const [releaseModalState, setReleaseModalState] = useState<{show: boolean, preQueueId?: number}>({
    show: false,
  })
  const [removeModalState, setRemoveModalState] = useState<{show: boolean, preQueueId?: number}>({
    show: false,
  })
  const [modalIncompatibleInvoices, setModalIncompatibleInvoices] = useState<boolean>(false)
  const [incompatibleInvoices, setIncompatibleInvoices] = useState<PreQueueIncompatibleInvoices>()
  const [preventDoubleClick, setPreventDoubleClick] = useState<boolean>(false)
  const { fc } = useFulfillmentCenter()
  const dispatch = useDispatch()
  const {
    handleSubmit,
    register,
    formState: { errors },
    clearErrors,
    setValue,
  } = useForm<FormType>()

  const closeReleaseModal = () => {
    setReleaseModalState({ ...releaseModalState, show: false })
    clearErrors()
    setValue('badge', '')
  }

  const closeRemoveModal = () => {
    setRemoveModalState({ ...removeModalState, show: false })
    clearErrors()
    setValue('badge', '')
  }

  const onConfirmReleaseModal = ({ badge }: FormType) => {
    if (!releaseModalState.preQueueId || preventDoubleClick) return

    setPreventDoubleClick(true)

    const onReleaseIncompatibleInvoices = (incompatibleInvoicesParam: PreQueueIncompatibleInvoices) => {
      setIncompatibleInvoices(incompatibleInvoicesParam)
      setModalIncompatibleInvoices(true)
    }

    dispatch(actions.releasePreQueueInvoices({
      badge,
      fcId: fc.id,
      preQueueId: releaseModalState.preQueueId,
      onReleaseIncompatibleInvoices,
      onFinally: () => setPreventDoubleClick(false),
    }))

    closeReleaseModal()
  }

  const onConfirmRemoveModal = ({ badge }: FormType) => {
    if (!removeModalState.preQueueId || preventDoubleClick) return

    setPreventDoubleClick(true)

    dispatch(actions.removePreQueueInvoices({
      badge,
      fcId: fc.id,
      preQueueId: removeModalState.preQueueId,
      onFinally: () => setPreventDoubleClick(false),
    }))

    closeRemoveModal()
  }

  const onCloseIncompatibleInvoicesModal = () => {
    setModalIncompatibleInvoices(false)
    setIncompatibleInvoices(undefined)
  }

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => setSearchTerm(e.target.value)

  const filteredPreQueueItems = supplierState?.preQueueItems.filter((item) =>
    item.invoices.filter((invoice) => invoice.invoiceKey.toLowerCase().includes(searchTerm.toLowerCase())).length > 0)

  const resolveTableRows = useMemo(() => filteredPreQueueItems.map((item) => {
    const onClickRelease = () => {
      setReleaseModalState({
        ...releaseModalState,
        preQueueId: item.id,
        show: true,
      })
    }

    const onClickRemove = () => {
      setRemoveModalState({
        ...removeModalState,
        preQueueId: item.id,
        show: true,
      })
    }

    const ResolveInvoices = () => (
      <div>
        {item.invoices.map((invoice, index) => !invoice.idAr && (
        <div key={index}>
          {invoice.invoiceKey}
          {invoice.ready ? <DoneIcon sx={invoiceReadyIconSx} color='success' /> : <CloseIcon sx={invoiceReadyIconSx} color='error' />}
        </div>
        ))}
      </div>
    )
    return {
      supplier: item.supplier?.nmFornecedor || item.supplierName,
      inputDate: formatDateUTC(item.createdAt),
      waitingTime: formatDifferenceFromNow(dayjs(item.createdAt)),
      pendingInvoices: <ResolveInvoices/>,
      action: (
        <ButtonContainer>
          <ButtonMui title='Liberar' variant='outlined' size='small' onClick={onClickRelease} />
          <ButtonMui title='Remover' variant='outlined' size='small' onClick={onClickRemove} color='error' />
        </ButtonContainer>
      ),
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }), [supplierState?.preQueueItems, filteredPreQueueItems])

  return (
    <Wrapper>
      <CustomTextField
        id='invoiceKey'
        name='invoiceKey'
        type='text'
        autoComplete='off'
        value={searchTerm}
        label='Buscar por chave da nota fiscal'
        fullWidth
        onChange={handleSearchChange}
      />
      <TableMui
        columns={[
          { id: 'supplier', label: 'Fornecedor' },
          { id: 'inputDate', label: 'Horário Chegada' },
          { id: 'waitingTime', label: 'Tempo Aguardando' },
          { id: 'pendingInvoices', label: 'Notas Pendentes de Conferência', useSorting: false },
          { id: 'action', label: 'Ações', useSorting: false },
        ]}
        rows={resolveTableRows}
        rowCount={resolveTableRows.length}
        enablePagination
        rowsPerPageLimit={10}
        rowsPerPageOptions={[5, 10, 25, 30, 50, 100, 200]}
        hasSorting
        maxHeight='59vh'
        testId='pre-queue-table-test-id'
      />
      <Modal
        title='Liberar nota fiscal'
        show={releaseModalState.show}
        closeButtonAction={closeReleaseModal}
        testId='release-modal'
        body={(
          <ModalForm onSubmit={handleSubmit(onConfirmReleaseModal)}>
            <div>Para liberar o recebimento bipe o crachá:</div>
            <TextFieldMui
              inputProps={{ ...register('badge', { required: true }) }}
              type='password'
              error={!!errors.badge}
              name='badge'
              label='badge'
              testId='badge'
              variant='outlined'
              disableSubmit
              autoFocus
              fullWidth
            />
            <ModalActionArea>
              <ButtonMui title='Liberar' color='success' variant='contained' data-testid='confirm' type='submit' />
              <ButtonMui title='Cancelar' color='error' variant='contained' onClick={closeReleaseModal} data-testid='cancel' />
            </ModalActionArea>
          </ModalForm>
        )}
      />
      <Modal
        title='Remover nota fiscal'
        show={removeModalState.show}
        closeButtonAction={closeRemoveModal}
        testId='remove-modal'
        body={(
          <ModalForm onSubmit={handleSubmit(onConfirmRemoveModal)}>
            <div>Para remover o fornecedor, bipe o crachá:</div>
            <TextFieldMui
              inputProps={{ ...register('badge', { required: true }) }}
              type='password'
              error={!!errors.badge}
              name='badge'
              label='badge'
              testId='badge'
              variant='outlined'
              disableSubmit
              autoFocus
              fullWidth
            />
            <ModalActionArea>
              <ButtonMui title='Remover' variant='contained' data-testid='confirm' type='submit' bgColor='blue'/>
              <ButtonMui title='Cancelar' color='error' variant='contained' onClick={closeRemoveModal} data-testid='cancel' />
            </ModalActionArea>
          </ModalForm>
        )}
      />
      <ModalAlert
        title='Notas incompatíveis'
        show={modalIncompatibleInvoices}
        closeButtonAction={onCloseIncompatibleInvoicesModal}
        action={onCloseIncompatibleInvoicesModal}
        testId='modal-incompatible-invoices-test-id'
        customizableBody={(
          <ModalIncompatibleInvoicesContainer>
            <Typography fontWeight='bold'>Existem notas fiscais incompatíveis que impedem a liberação da pré-fila.</Typography>
            {incompatibleInvoices && (
              <ModalIncompatibleInvoicesContainerItems>
                {incompatibleInvoices.regular.invoices.length > 0 && (
                <ModalIncompatibleInvoicesContainerInvoices>
                  <Typography>Notas de Fornecedor ({incompatibleInvoices.regular.message}):</Typography>
                  <ModalIncompatibleInvoicesContainerInvoicesList>
                    {incompatibleInvoices.regular.invoices.map((invoice) => (
                      <ModalIncompatibleInvoicesContainerInvoicesListItem key={invoice}>
                        {invoice}
                      </ModalIncompatibleInvoicesContainerInvoicesListItem>
                    ))}
                  </ModalIncompatibleInvoicesContainerInvoicesList>
                </ModalIncompatibleInvoicesContainerInvoices>
                )}
                {incompatibleInvoices.externalOrder.invoices.length > 0 && (
                <ModalIncompatibleInvoicesContainerInvoices>
                  <Typography>Notas de Compras Externas ({incompatibleInvoices.externalOrder.message}):</Typography>
                  <ModalIncompatibleInvoicesContainerInvoicesList>
                    {incompatibleInvoices.externalOrder.invoices.map((invoice) => (
                      <ModalIncompatibleInvoicesContainerInvoicesListItem key={invoice}>
                        {invoice}
                      </ModalIncompatibleInvoicesContainerInvoicesListItem>
                    ))}
                  </ModalIncompatibleInvoicesContainerInvoicesList>
                </ModalIncompatibleInvoicesContainerInvoices>
                )}
                {incompatibleInvoices.transferOrderRegular.invoices.length > 0 && (
                <ModalIncompatibleInvoicesContainerInvoices>
                  <Typography>Notas de Transferências ({incompatibleInvoices.transferOrderRegular.message}):</Typography>
                  <ModalIncompatibleInvoicesContainerInvoicesList>
                    {incompatibleInvoices.transferOrderRegular.invoices.map((invoice) => (
                      <ModalIncompatibleInvoicesContainerInvoicesListItem key={invoice}>
                        {invoice}
                      </ModalIncompatibleInvoicesContainerInvoicesListItem>
                    ))}
                  </ModalIncompatibleInvoicesContainerInvoicesList>
                </ModalIncompatibleInvoicesContainerInvoices>
                )}
                {incompatibleInvoices.transferOrder.invoices.length > 0 && (
                <ModalIncompatibleInvoicesContainerInvoices>
                  <Typography>Notas de Transferências ({incompatibleInvoices.transferOrder.message}):</Typography>
                  <ModalIncompatibleInvoicesContainerInvoicesList>
                    {incompatibleInvoices.transferOrder.invoices.map((invoice) => (
                      <ModalIncompatibleInvoicesContainerInvoicesListItem key={invoice}>
                        {invoice}
                      </ModalIncompatibleInvoicesContainerInvoicesListItem>
                    ))}
                  </ModalIncompatibleInvoicesContainerInvoicesList>
                </ModalIncompatibleInvoicesContainerInvoices>
                )}
              </ModalIncompatibleInvoicesContainerItems>
            )}
          </ModalIncompatibleInvoicesContainer>
        )}
      />
    </Wrapper>
  )
}
